import { WizardPageConfig } from "../WizardPageController/WizardPageController.utils";

export const COI_REVIEW_PURPOSE = "COI Review";

export type WizardPage = {
  id: number;
  flag: boolean;
  label: string;
};

export type WizardHeaderPaginationProps<CustomSharedData> = {
  config: WizardPageConfig[];
  purpose: string;
  activeStep: number;
  setActiveStep: (arg: number) => void;
  sharedData: CustomSharedData;
  setSharedData: React.Dispatch<React.SetStateAction<CustomSharedData>>;
  onComplete: (arg: any, status?: "Approved" | "Rejected") => void;
  onSaveAsDraft?: () => void;
  coiSaving?: "draft" | "submit" | null;
  coiAllDecided?: boolean;
  onCoiSaveDraft?: () => void;
  onCoiSubmit?: () => void;
};
